import React from 'react';
import DsSelect from '../DsSelect';
import { formatDateJP, toHHmm } from '../../../utils/datetime';

const Select = DsSelect as unknown as React.ComponentType<any>;

export type EventPerformanceScopeOption = {
  id?: number | null;
  performanceIndex?: number | null;
  name?: string | null;
  date?: string | null;
  startTime?: string | null;
};

type Props = {
  performances: EventPerformanceScopeOption[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
  includeUnselected?: boolean;
  hideForSinglePerformance?: boolean;
};

export function performanceScopeValue(
  performance: EventPerformanceScopeOption,
  fallbackIndex: number
) {
  if (Number.isInteger(performance.id) && Number(performance.id) > 0) {
    return `id:${Number(performance.id)}`;
  }
  const performanceIndex = Number.isInteger(performance.performanceIndex)
    ? Number(performance.performanceIndex)
    : fallbackIndex;
  return `index:${performanceIndex}`;
}

export function performanceScopeLabel(
  performance: EventPerformanceScopeOption,
  fallbackIndex: number
) {
  const date = formatDateJP(performance.date) || '日付未設定';
  const time = toHHmm(performance.startTime);
  const name = String(performance.name || '').trim() || `公演${fallbackIndex + 1}`;
  return `${date}${time ? ` ${time}` : ''} / ${name}`;
}

export default function EventPerformanceScopeSelect({
  performances,
  value,
  onChange,
  ariaLabel = '対象',
  disabled = false,
  includeUnselected = false,
  hideForSinglePerformance = true,
}: Props) {
  if (hideForSinglePerformance && performances.length <= 1) return null;

  return (
    <Select
      aria-label={ariaLabel}
      value={value}
      disabled={disabled}
      onChange={(event: React.ChangeEvent<HTMLSelectElement>) => onChange(event.target.value)}
    >
      {includeUnselected ? <option value="" disabled>対象を選択してください</option> : null}
      <option value="event">イベント全体（通し券など）</option>
      {performances.map((performance, index) => (
        <option
          key={performanceScopeValue(performance, index)}
          value={performanceScopeValue(performance, index)}
        >
          {performanceScopeLabel(performance, index)}
        </option>
      ))}
    </Select>
  );
}
